import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import '../styles/candidates-page.css';
import ProfileDropdown from '../components/ProfileDropdown';
import PrettySelect from '../components/PrettySelect';
import Toast from '../components/Toast';
import API from '../api/api';
import { getStoredTokenForRole, getStoredUserForRole } from '../utils/authStorage';
 
/* ─────────────────────────────────────────
    SIDEBAR ICONS  (exact from recruiter page)
───────────────────────────────────────── */
const IconHome = ({ active }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_home)">
      <path d="M9.99638 13.9949V8.6635C9.99638 8.48675 9.92617 8.31724 9.80119 8.19226C9.67621 8.06728 9.5067 7.99707 9.32995 7.99707H6.66423C6.48748 7.99707 6.31798 8.06728 6.193 8.19226C6.06802 8.31724 5.9978 8.48675 5.9978 8.6635V13.9949" stroke={active ? 'white' : '#26282B'} strokeWidth="1.33286" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.99927 6.6641C1.99922 6.47021 2.04148 6.27865 2.12308 6.10278C2.20469 5.9269 2.32368 5.77095 2.47177 5.6458L7.13678 1.64788C7.37735 1.44456 7.68215 1.33301 7.99714 1.33301C8.31212 1.33301 8.61693 1.44456 8.8575 1.64788L13.5225 5.6458C13.6706 5.77095 13.7896 5.9269 13.8712 6.10278C13.9528 6.27865 13.9951 6.47021 13.995 6.6641V12.662C13.995 13.0155 13.8546 13.3545 13.6046 13.6044C13.3547 13.8544 13.0156 13.9948 12.6621 13.9948H3.33213C2.97863 13.9948 2.63961 13.8544 2.38965 13.6044C2.13969 13.3545 1.99927 13.0155 1.99927 12.662V6.6641Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.33286" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs><clipPath id="clip0_home"><rect width="15.9943" height="15.9943" fill="white"/></clipPath></defs>
  </svg>
);
 
const IconCandidates = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      stroke={active ? 'white' : '#26282B'}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="9"
      cy="7"
      r="4"
      stroke={active ? 'white' : '#26282B'}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 21v-2a4 4 0 0 0-3-3.87"
      stroke={active ? 'white' : '#26282B'}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.13a4 4 0 0 1 0 7.75"
      stroke={active ? 'white' : '#26282B'}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
 
const IconQuestionBank = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 14.167H10.0083" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.4999 1.66699H4.99992C4.55789 1.66699 4.13397 1.84259 3.82141 2.15515C3.50885 2.46771 3.33325 2.89163 3.33325 3.33366V16.667C3.33325 17.109 3.50885 17.5329 3.82141 17.8455C4.13397 18.1581 4.55789 18.3337 4.99992 18.3337H14.9999C15.4419 18.3337 15.8659 18.1581 16.1784 17.8455C16.491 17.5323 16.6666 17.109 16.6666 16.667V5.83366L12.4999 1.66699Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.58325 7.49982C7.78323 6.94867 8.17056 6.48535 8.67753 6.19084C9.18449 5.89633 9.77884 5.78937 10.3567 5.88865C10.9345 5.98793 11.4591 6.28715 11.8387 6.73399C12.2182 7.18083 12.4287 7.74686 12.4333 8.33315C12.4333 9.99982 9.93325 10.8331 9.93325 10.8331" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
 
const IconExamManagement = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M12.5001 1.66699H7.50008C7.03984 1.66699 6.66675 2.04009 6.66675 2.50033V4.16699C6.66675 4.62723 7.03984 5.00033 7.50008 5.00033H12.5001C12.9603 5.00033 13.3334 4.62723 13.3334 4.16699V2.50033C13.3334 2.04009 12.9603 1.66699 12.5001 1.66699Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3333 3.33301H14.9999C15.4419 3.33301 15.8659 3.5086 16.1784 3.82116C16.491 4.13372 16.6666 4.55765 16.6666 4.99967V16.6663C16.6666 17.1084 16.491 17.5323 16.1784 17.8449C15.8659 18.1574 15.4419 18.333 14.9999 18.333H4.99992C4.55789 18.333 4.13397 18.1574 3.82141 17.8449C3.50885 17.5323 3.33325 17.1084 3.33325 16.6663V4.99967C3.33325 4.55765 3.50885 4.13372 3.82141 3.82116C4.13397 3.5086 4.55789 3.33301 4.99992 3.33301H6.66659" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 9.16699H13.3333" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 13.333H13.3333" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66675 9.16699H6.67508" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66675 13.333H6.67508" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
 
const IconAnalytics = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 2.5V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 14.1667V7.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.8333 14.167V4.16699" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66675 14.167V11.667" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
 
const IconSectionsInline = ({ active }) => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2.5 5H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round"/><path d="M2.5 10H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round"/><path d="M2.5 15H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round"/></svg>);

const IconDrive = ({ active }) => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.333 6.667h13.334M5 3.333h10c.92 0 1.667.746 1.667 1.667v10c0 .92-.746 1.667-1.667 1.667H5A1.667 1.667 0 0 1 3.333 15V5c0-.92.746-1.667 1.667-1.667Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M7 10h.01M10 10h3M7 13h.01M10 13h3" stroke={active ? 'white' : '#26282B'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>);
 
const sidebarItems = [
  { label: 'Home',            Icon: IconHome,              path: '/recruiter' },
  { label: 'Drives',          Icon: IconDrive,             path: '/drives' },
  { label: 'Exam Management', Icon: IconExamManagement,    path: '/exam-management' },
  { label: 'Candidates',      Icon: IconCandidates,        path: '/candidates' },
  { label: 'Sections',        Icon: IconSectionsInline,    path: '/sections' },
  { label: 'Question Bank',   Icon: IconQuestionBank,      path: '/question-bank' },
  { label: 'Analytics',       Icon: IconAnalytics,         path: '/analytics' },
];
 
/* ─────────────────────────────────────────
    STATUS ICON COMPONENTS
───────────────────────────────────────── */
const CheckIcon = ({ color }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="7" cy="7" r="5.25" stroke={color} strokeWidth="1.5"/>
    <path d="M4.667 7L6.083 8.417L9.333 5.167" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
 
const UserCheckIcon = ({ color }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M9.333 12.25V11.083C9.333 10.467 9.087 9.877 8.649 9.439C8.211 9.001 7.621 8.75 7 8.75H3.5C2.879 8.75 2.289 9.001 1.851 9.439C1.413 9.877 1.167 10.467 1.167 11.083V12.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.25 5.833C6.493 5.833 7.5 4.826 7.5 3.583C7.5 2.34 6.493 1.333 5.25 1.333C4.007 1.333 3 2.34 3 3.583C3 4.826 4.007 5.833 5.25 5.833Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.333 6.417L10.083 7.167L12.25 5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
 
const ClockIcon = ({ color }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="7" cy="7" r="5.833" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 3.5V7L9.333 8.167" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
 
const StatusIcon = ({ type, color }) => {
  if (type === 'check') return <CheckIcon color={color} />;
  if (type === 'user-check') return <UserCheckIcon color={color} />;
  if (type === 'clock') return <ClockIcon color={color} />;
  return null;
};
 
/* ─────────────────────────────────────────
    SCORE CIRCLE COMPONENT
───────────────────────────────────────── */
/* ─────────────────────────────────────────
    CHEVRON DOWN
───────────────────────────────────────── */
/* ─────────────────────────────────────────
    SINGLE ENTRY FORM (IMAGE 02)
───────────────────────────────────────── */
const SingleEntryForm = ({ onClose, onNotify }) => {
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', mobileNo: '', skill: '', collegeName: '', degree: '' });
  const [loading, setLoading] = useState(false);
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, mobileNo, skill, collegeName, degree } = formData;
    if (!firstName.trim() || !lastName.trim() || !email.trim() || !mobileNo.trim() || !skill.trim()) return;
    if (!/^\d{10}$/.test(mobileNo.trim())) {
      onNotify?.({ message: 'Mobile number must be exactly 10 digits with no letters or special characters', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      const token = getStoredTokenForRole('recruiter');
      const res = await fetch('/api/users/candidates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ firstName: firstName.trim(), lastName: lastName.trim(), email: email.trim(), mobileNo: mobileNo.trim(), company: 'inteliment', skill, collegeName: collegeName.trim(), degree: degree.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { onNotify?.({ message: data.message || 'Failed to create candidate', type: 'error' }); return; }
      onNotify?.({
        message: 'Candidate created successfully.',
        type: 'success',
      });
      onClose();
    } catch {
      onNotify?.({ message: 'Server error', type: 'error' });
    } finally { setLoading(false); }
  };
 
  return (
  <div className="cp-modal-overlay" onClick={onClose}>
    <div className="cp-modal cp-modal-form" onClick={e => e.stopPropagation()}>
      <button className="cp-modal-close" onClick={onClose}>
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path d="M10 1L1 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
          <path d="M1 1L10 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
        </svg>
      </button>
 
      <h2 className="cp-modal-title" style={{ alignSelf: 'flex-start' }}>Add Candidate</h2>
      <p className="cp-modal-subtitle" style={{ alignSelf: 'flex-start', textAlign: 'left', maxWidth: 'none' }}>Enter Candidate Details To Get Started.</p>
 
      <form className="cp-form-grid" onSubmit={handleSubmit}>
        <div className="cp-form-group" style={{ gridColumn: 1, gridRow: 1 }}>
          <label>First Name<span className="required-star">*</span></label>
          <input type="text" placeholder="Enter first name" value={formData.firstName} onChange={e => setFormData(p => ({...p, firstName: e.target.value}))} required />
        </div>
        <div className="cp-form-group" style={{ gridColumn: 2, gridRow: 1 }}>
          <label>Last Name<span className="required-star">*</span></label>
          <input type="text" placeholder="Enter last name" value={formData.lastName} onChange={e => setFormData(p => ({...p, lastName: e.target.value}))} required />
        </div>
        <div className="cp-form-group" style={{ gridColumn: 1, gridRow: 2 }}>
          <label>Email<span className="required-star">*</span></label>
          <input type="email" placeholder="Enter email" value={formData.email} onChange={e => setFormData(p => ({...p, email: e.target.value}))} required />
        </div>
        <div className="cp-form-group cp-skill-group" style={{ gridColumn: 2, gridRow: 2 }}>
          <label>Primary Skill<span className="required-star">*</span></label>
          <input
            type="text"
            className="cp-form-input-text"
            placeholder="e.g. Frontend, Backend, DevOps..."
            value={formData.skill}
            onChange={e => setFormData(p => ({...p, skill: e.target.value}))}
            required
          />
        </div>
        <div className="cp-form-group" style={{ gridColumn: 1, gridRow: 3 }}>
          <label>Mobile No.<span className="required-star">*</span></label>
          <input type="tel" placeholder="Enter mobile number" value={formData.mobileNo} onChange={e => setFormData(p => ({...p, mobileNo: e.target.value}))} required />
        </div>
        <div className="cp-form-group" style={{ gridColumn: 2, gridRow: 3 }}>
          <label>College Name</label>
          <input type="text" placeholder="Enter college name" value={formData.collegeName} onChange={e => setFormData(p => ({...p, collegeName: e.target.value}))} />
        </div>
        <div className="cp-form-group" style={{ gridColumn: 1, gridRow: 4 }}>
          <label>Degree</label>
          <input type="text" placeholder="Enter degree" value={formData.degree} onChange={e => setFormData(p => ({...p, degree: e.target.value}))} />
        </div>
        <button type="submit" className="cp-add-btn cp-form-submit" disabled={loading}
          style={{ alignSelf: 'flex-end', marginTop: '20px', gridColumn: '1 / span 2', justifySelf: 'end' }}>
          {loading ? 'Adding...' : 'Add Candidate'}
        </button>
      </form>
    </div>
  </div>
  );
};

const PencilIcon = () => (
  <svg width="15" height="15" viewBox="0 0 20 20" fill="none">
    <path d="M11.7 4.1 15.9 8.3M3.3 16.7l4.4-.9 8.7-8.7a2 2 0 0 0-2.8-2.8L4.9 13l-1.6 3.7Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EditCandidateModal = ({ candidate, onClose, onSaved, onNotify }) => {
  const [form, setForm] = useState({
    name: candidate.name || '',
    email: candidate.email || '',
    mobileNo: candidate.mobile_no || candidate.mobileNo || '',
    collegeName: candidate.college_name || candidate.college || '',
    degree: candidate.degree || '',
    skill: candidate.skill || '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.mobileNo.trim()) return;
    if (!/^\d{10}$/.test(form.mobileNo.trim())) {
      onNotify?.({ message: 'Mobile number must be exactly 10 digits with no letters or special characters', type: 'error' });
      return;
    }
    setSaving(true);
    try {
      const res = await API.put(`/users/candidates/${candidate.id}`, form);
      onSaved(res.data?.candidate || { ...candidate, ...form, college_name: form.collegeName });
      onNotify?.({ message: 'Candidate updated successfully.', type: 'success' });
      onClose();
    } catch (err) {
      onNotify?.({ message: err.response?.data?.message || 'Failed to update candidate.', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cp-modal-overlay" onClick={onClose}>
      <div className="cp-modal cp-modal-form" onClick={e => e.stopPropagation()}>
        <button className="cp-modal-close" onClick={onClose}>
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M10 1L1 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
            <path d="M1 1L10 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
          </svg>
        </button>
        <h2 className="cp-modal-title" style={{ alignSelf: 'flex-start' }}>Edit Candidate</h2>
        <p className="cp-modal-subtitle" style={{ alignSelf: 'flex-start', textAlign: 'left', maxWidth: 'none' }}>Update candidate profile details.</p>
        <form className="cp-form-grid" onSubmit={handleSubmit}>
          {[
            ['Name', 'name', 'Enter full name', 'text'],
            ['Email', 'email', 'Enter email', 'email'],
            ['Mobile No.', 'mobileNo', 'Enter mobile number', 'tel'],
            ['College', 'collegeName', 'Enter college name', 'text'],
            ['Degree', 'degree', 'Enter degree', 'text'],
            ['Primary Skill', 'skill', 'e.g. Frontend, Backend', 'text'],
          ].map(([label, key, placeholder, type], index) => (
            <div key={key} className="cp-form-group" style={{ gridColumn: index === 5 ? '1 / span 2' : (index % 2) + 1 }}>
              <label>{label}{['name', 'email', 'mobileNo'].includes(key) && <span className="required-star">*</span>}</label>
              <input
                type={type}
                placeholder={placeholder}
                value={form[key]}
                onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
                required={['name', 'email', 'mobileNo'].includes(key)}
              />
            </div>
          ))}
          <button type="submit" className="cp-add-btn cp-form-submit" disabled={saving} style={{ gridColumn: '1 / span 2', justifySelf: 'end' }}>
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
};
 
/* ─────────────────────────────────────────
    BULK UPLOAD FORM (NEW)
───────────────────────────────────────── */
const BulkUploadForm = ({ onClose, onNotify }) => {
  const [dragging, setDragging] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
 
  const handleDragOver = (e) => { e.preventDefault(); setDragging(true); };
  const handleDragLeave = () => setDragging(false);
  const handleDrop = (e) => { e.preventDefault(); setDragging(false); const f = e.dataTransfer.files[0]; if (f) setFile(f); };
  const handleFileChange = (e) => { if (e.target.files[0]) setFile(e.target.files[0]); };
  const handleClearFile = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
 
  const downloadTemplate = () => {
    const csv = 'first_name,last_name,email,mobile_no,college,degree,primary_skill\n';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'candidates-template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };
 
  const handleUpload = async () => {
    if (!file) return;
    setUploading(true);
    try {
      const text = await file.text();
      const lines = text.trim().split('\n').filter(Boolean);
      const headers = lines[0].split(',').map(h => h.trim().replace(/^\uFEFF/, ''));
      const candidates = lines.slice(1).map(line => {
        const vals = line.split(',').map(v => v.trim());
        const obj = {};
        headers.forEach((h, i) => obj[h] = vals[i] || '');
        return obj;
      }).filter(c => c.first_name && c.last_name && c.email);
 
      const token = getStoredTokenForRole('recruiter');
      const res = await fetch('/api/users/candidates/bulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ candidates }),
      });
      const data = await res.json();
      if (!res.ok) { onNotify?.({ message: data.message || 'Upload failed', type: 'error' }); return; }
      onNotify?.({
        message: `${data.created?.length || 0} candidates created successfully.`,
        type: 'success',
      });
      onClose();
    } catch (e) {
      onNotify?.({ message: 'Error processing file', type: 'error' });
    } finally {
      setUploading(false);
    }
  };
 
  return (
    <div className="cp-modal-overlay" onClick={onClose}>
      <div className="cp-bulk-modal" onClick={e => e.stopPropagation()}>
        <button className="cp-modal-close" onClick={onClose}>
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M10 1L1 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
            <path d="M1 1L10 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
          </svg>
        </button>
 
        <div className="cp-bulk-header">
          <h2 className="cp-bulk-title">Bulk Upload Candidates</h2>
          <p className="cp-bulk-subtitle">Upload a CSV file with columns: first_name, last_name, email, mobile_no, college, degree, primary_skill</p>
        </div>
 
        <button className="cp-bulk-download-link" onClick={downloadTemplate}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 13V5M10 13L7 10M10 13L13 10" stroke="#3B82F6" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 14V15.5C4 16.328 4.672 17 5.5 17H14.5C15.328 17 16 16.328 16 15.5V14" stroke="#3B82F6" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Download Template</span>
        </button>
 
        <div
          className={`cp-bulk-dropzone${dragging ? ' cp-bulk-dropzone--active' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="cp-bulk-upload-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <rect width="48" height="48" rx="24" fill="#EFF6FF"/>
              <path d="M24 30V18M24 18L19 23M24 18L29 23" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 30V31.5C16 32.328 16.672 33 17.5 33H30.5C31.328 33 32 32.328 32 31.5V30" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          {file ? (
            <div className="cp-bulk-file-selected">
              <p className="cp-bulk-drop-text" style={{ color: '#155DFC', fontWeight: 500 }}>{file.name}</p>
              <button type="button" className="cp-bulk-file-clear" onClick={handleClearFile}>
                Clear File
              </button>
            </div>
          ) : (
            <p className="cp-bulk-drop-text">Drag &amp; drop your CSV file here</p>
          )}
          <label className="cp-bulk-browse">
            or <span>browse files</span>
            <input ref={fileInputRef} type="file" accept=".csv" style={{ display: 'none' }} onChange={handleFileChange} />
          </label>
        </div>
 
        <div className="cp-bulk-guidelines">
          <span>Accepted format: CSV</span>
          <span>Columns: first_name, last_name, email, mobile_no, college, degree, primary_skill</span>
        </div>
 
        <button
          className={`cp-bulk-upload-btn${file ? ' cp-bulk-upload-btn--active' : ''}`}
          disabled={!file || uploading}
          onClick={handleUpload}
        >
          {uploading ? 'Uploading...' : 'Upload & Create Candidates'}
        </button>
      </div>
    </div>
  );
};
 
/* ─────────────────────────────────────────
    ASSIGN EXAM MODAL
───────────────────────────────────────── */
const AssignExamModal = ({ candidateIds, onClose, onAssigned }) => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [assignedExamIds, setAssignedExamIds] = useState(new Set());
  const [selectedExam, setSelectedExam] = useState(null);
  const [dueDate, setDueDate] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
 
  useEffect(() => {
    const token = getStoredTokenForRole('recruiter');
    const fetchExams = fetch('/api/exam/recruiter', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => (Array.isArray(data) ? data : []).filter(e => e.status === 'active'));
 
    // For single candidate, fetch their already-assigned exams
    const fetchAssigned = candidateIds.length === 1
      ? fetch(`/api/users/candidates/${candidateIds[0]}/assigned-exams`, { headers: { Authorization: `Bearer ${token}` } })
          .then(r => r.json()).then(d => new Set((d.examIds || []).map(Number)))
      : Promise.resolve(new Set());
 
    Promise.all([fetchExams, fetchAssigned])
      .then(([activeExams, alreadyAssigned]) => {
        setExams(activeExams);
        setAssignedExamIds(alreadyAssigned);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [candidateIds]);

  const handleExamToggle = (examId, alreadyAssigned) => {
    if (alreadyAssigned) return;

    setErr('');
    setSelectedExam(prev => (prev === examId ? null : examId));
  };
 
  const handleAssign = async () => {
    if (!selectedExam) { setErr('Please select an exam'); return; }
    if (assignedExamIds.has(selectedExam)) { setErr('This exam is already assigned to this candidate.'); return; }
    setSaving(true); setErr('');
    try {
      const token = getStoredTokenForRole('recruiter');
      const res = await fetch(`/api/exam/${selectedExam}/assign`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ candidateIds, newCandidates: [], dueDate: dueDate || null }),
      });
      const data = await res.json();
      if (!res.ok) { setErr(data.message || 'Assignment failed'); return; }
      if (data.skippedCount > 0 && data.assignedCount === 0) {
        setErr(data.message || 'This exam is already assigned to all selected candidates.');
        return;
      }
      onAssigned();
      window.setTimeout(onClose, 1000);
    } catch { setErr('Server error'); } finally { setSaving(false); }
  };
 
  const isSingleCandidate = candidateIds.length === 1;
 
  return (
    <div className="cp-modal-overlay" onClick={onClose}>
      <div className="cp-assign-modal" onClick={e => e.stopPropagation()}>
        <button className="cp-modal-close" onClick={onClose}>
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M10 1L1 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
            <path d="M1 1L10 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
          </svg>
        </button>
        <h2 className="cp-modal-title" style={{ textAlign: 'left' }}>Assign Exam</h2>
        <p className="cp-modal-subtitle" style={{ textAlign: 'left' }}>
          Assigning to <strong>{candidateIds.length}</strong> candidate{candidateIds.length !== 1 ? 's' : ''}
        </p>
 
        {loading ? (
          <p style={{ color: '#64748B', padding: '1rem 0' }}>Loading exams...</p>
        ) : exams.length === 0 ? (
          <p style={{ color: '#EF4444', padding: '1rem 0' }}>No active exams available. Publish an exam first.</p>
        ) : (
          <div className="cp-exam-list">
            {exams.map(ex => {
              const alreadyAssigned = isSingleCandidate && assignedExamIds.has(ex.id);
              return (
                <label
                  key={ex.id}
                  className={`cp-exam-option ${selectedExam === ex.id ? 'cp-exam-option--selected' : ''} ${alreadyAssigned ? 'cp-exam-option--disabled' : ''}`}
                  title={alreadyAssigned ? 'Already assigned to this candidate' : ''}
                  onClick={() => handleExamToggle(ex.id, alreadyAssigned)}
                >
                  <input
                    type="radio"
                    name="exam"
                    value={ex.id}
                    checked={selectedExam === ex.id}
                    disabled={alreadyAssigned}
                    onChange={() => {}}
                  />
                  <div className="cp-exam-option-info">
                    <span className="cp-exam-option-title" title={ex.title}>{ex.title}</span>
                    <span className="cp-exam-option-meta">{ex.question_count || 0} questions · {ex.duration_minutes || 0} min</span>
                  </div>
                  {alreadyAssigned && <span className="cp-exam-assigned-badge">Already Assigned</span>}
                </label>
              );
            })}
          </div>
        )}
 
        <div className="cp-assign-due">
          <label style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#374151' }}>Due Date (optional)</label>
          <input
            type="date"
            className="cp-assign-date-input"
            value={dueDate}
            min={new Date().toISOString().split('T')[0]}
            onChange={e => setDueDate(e.target.value)}
          />
        </div>
 
        {err && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#FFF1F2', border: '1px solid #FECDD3', borderRadius: '8px', padding: '10px 12px', marginTop: '0.75rem' }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#BE123C" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
            <span style={{ color: '#BE123C', fontSize: '0.8125rem', fontWeight: 500 }}>{err}</span>
          </div>
        )}
 
        <div className="cp-modal-actions" style={{ justifyContent: 'flex-end', marginTop: '1.25rem' }}>
          <button className="cp-modal-btn" style={{ background: '#F3F4F6', color: '#374151', border: 'none' }} onClick={onClose}>Cancel</button>
          <button className="cp-add-btn" disabled={saving || !selectedExam || (isSingleCandidate && assignedExamIds.has(selectedExam))} onClick={handleAssign} style={{ minWidth: '120px' }}>
            {saving ? 'Assigning...' : 'Assign Exam'}
          </button>
        </div>
      </div>
    </div>
  );
};
 
/* ─────────────────────────────────────────
    ADD CANDIDATE MODAL (SELECTION)
───────────────────────────────────────── */
const AddCandidateModal = ({ onClose, onSingleEntry, onBulkUpload }) => (
  <div className="cp-modal-overlay" onClick={onClose}>
    <div className="cp-modal" onClick={e => e.stopPropagation()}>
      <button className="cp-modal-close" onClick={onClose}>
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path d="M10 1L1 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
          <path d="M1 1L10 10" stroke="#94A3B8" strokeWidth="1.84" strokeLinecap="round"/>
        </svg>
      </button>
 
      <h2 className="cp-modal-title">Add Candidates</h2>
      <p className="cp-modal-subtitle">Select how you would like to add candidate details</p>
 
      <div className="cp-modal-actions">
        <button className="cp-modal-btn" onClick={onSingleEntry}>
          <span className="cp-modal-btn-icon">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M9 10.5V9.5C9 8.97 8.789 8.462 8.414 8.086C8.038 7.711 7.53 7.5 7 7.5H4C3.47 7.5 2.962 7.711 2.586 8.086C2.211 8.462 2 8.97 2 9.5V10.5" stroke="#4683E5" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.5 5.5C6.605 5.5 7.5 4.605 7.5 3.5C7.5 2.395 6.605 1.5 5.5 1.5C4.395 1.5 3.5 2.395 3.5 3.5C3.5 4.605 4.395 5.5 5.5 5.5Z" stroke="#4683E5" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9.5 4V7" stroke="#4683E5" strokeWidth="1" strokeLinecap="round"/>
              <path d="M8 5.5H11" stroke="#4683E5" strokeWidth="1" strokeLinecap="round"/>
            </svg>
          </span>
          Single Entry
        </button>
 
        <button className="cp-modal-btn" onClick={onBulkUpload}>
          <span className="cp-modal-btn-icon">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M10 7.5V9.5C10 9.765 9.895 10.02 9.707 10.207C9.52 10.395 9.265 10.5 9 10.5H3C2.735 10.5 2.48 10.395 2.293 10.207C2.105 10.02 2 9.765 2 9.5V7.5" stroke="#4683E5" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8.5 4L6 1.5L3.5 4" stroke="#4683E5" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 1.5V7.5" stroke="#4683E5" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
          Bulk Upload
        </button>
      </div>
    </div>
  </div>
);
 
/* ─────────────────────────────────────────
    MAIN COMPONENT
───────────────────────────────────────── */
const CandidatePage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [examFilter, setExamFilter] = useState('All');
  const [dateFilter, setDateFilter] = useState('All');
  const [showModal, setShowModal] = useState(false);
  const [modalStep, setModalStep] = useState('selection');
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignTargetIds, setAssignTargetIds] = useState([]);
  const [candidateDetail, setCandidateDetail] = useState(null);
  const [candidateToEdit, setCandidateToEdit] = useState(null);
  const [candidateEvidenceLoading, setCandidateEvidenceLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const screenshotBlobUrlsRef = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();
 
  const storedUser = getStoredUserForRole('recruiter');
  const selectIcons = {
    status: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L14.6 7.4L20 10L14.6 12.6L12 18L9.4 12.6L4 10L9.4 7.4L12 2Z" stroke="#7AA2F7" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    exam: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <rect x="5" y="3" width="14" height="18" rx="2" stroke="#7AA2F7" strokeWidth="1.7"/>
        <path d="M9 7H15M9 11H15M9 15H13" stroke="#7AA2F7" strokeWidth="1.7" strokeLinecap="round"/>
      </svg>
    ),
    date: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="5" width="18" height="16" rx="2" stroke="#7AA2F7" strokeWidth="1.7"/>
        <path d="M16 3V7M8 3V7M3 10H21" stroke="#7AA2F7" strokeWidth="1.7" strokeLinecap="round"/>
      </svg>
    ),
  };
 
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const token = getStoredTokenForRole('recruiter');
        const res = await fetch('/api/users/candidates', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok) setCandidates(data.candidates || []);
      } catch (e) {
        console.error('Failed to fetch candidates', e);
      } finally {
        setLoading(false);
      }
    };
    fetchCandidates();
  }, []);
 
  const handleOpenModal = () => {
    setModalStep('selection');
    setShowModal(true);
  };

  const handleToast = ({ message, type = 'success' }) => {
    setToast({ message, type });
  };
 
  const openAssignModal = (ids) => {
    setAssignTargetIds(ids);
    setShowAssignModal(true);
  };

  const clearScreenshotBlobUrls = () => {
    screenshotBlobUrlsRef.current.forEach((url) => window.URL.revokeObjectURL(url));
    screenshotBlobUrlsRef.current = [];
  };

  const formatViolationLabel = (submitReason, tabSwitchCount) => {
    if (submitReason === 'tab_switch') return `Tab switch (${tabSwitchCount || 0})`;
    if (submitReason === 'screen_share_stopped') return 'Screen share stopped';
    if (submitReason === 'timeout') return 'Timed out';
    if (submitReason === 'manual') return 'None';
    return submitReason ? submitReason.replace(/_/g, ' ') : 'None';
  };

  const handleOpenCandidateDetail = async (candidate) => {
    clearScreenshotBlobUrls();
    setCandidateDetail({
      ...candidate,
      examTitle: candidate.exam_title || '—',
      screenshots: [],
    });
    setCandidateEvidenceLoading(true);

    try {
      const res = await API.get(`/exam/screenshots/${candidate.id}`);
      const data = res.data;
      const screenshotEntries = Array.isArray(data?.screenshots) ? data.screenshots : [];
      const screenshots = await Promise.all(
        screenshotEntries.map(async (entry) => {
          const filename = typeof entry === 'string' ? entry : entry?.filename;
          if (!filename) return null;

          try {
            const fileRes = await API.get(`/exam/screenshot/${encodeURIComponent(filename)}`, {
              responseType: 'blob',
            });
            const blobUrl = window.URL.createObjectURL(fileRes.data);
            screenshotBlobUrlsRef.current.push(blobUrl);
            return { filename, blobUrl };
          } catch {
            return null;
          }
        })
      );

      setCandidateDetail(prev => (prev ? {
        ...prev,
        screenshots: screenshots.filter(Boolean),
      } : prev));
    } catch {
      setCandidateDetail(prev => (prev ? { ...prev, screenshots: [] } : prev));
    } finally {
      setCandidateEvidenceLoading(false);
    }
  };

  const handleOpenScreenshot = (blobUrl) => {
    try {
      window.open(blobUrl, '_blank', 'noopener,noreferrer');
    } catch {
      handleToast({ message: 'Could not open screenshot.', type: 'error' });
    }
  };

  useEffect(() => () => clearScreenshotBlobUrls(), []);
 
  const handleAssigned = async () => {
    setSelectedIds(new Set());
    const token = getStoredTokenForRole('recruiter');
    const res = await fetch('/api/users/candidates', { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    if (res.ok) setCandidates(data.candidates || []);
  };

  const handleCandidateSaved = (updatedCandidate) => {
    setCandidates(prev => prev.map(c => c.id === updatedCandidate.id
      ? { ...c, ...updatedCandidate, college_name: updatedCandidate.college_name ?? c.college_name }
      : c
    ));
  };
 
  // Derive unique exam titles for the Exam filter dropdown
  const examOptions = [
    { value: 'All', label: 'All Exams' },
    ...Array.from(new Set(candidates.map(c => c.exam_title).filter(Boolean))).map((title) => ({
      value: title,
      label: title,
    })),
  ];
  const statusOptions = [
    { value: 'All', label: 'All Status' },
    { value: 'Shortlisted', label: 'Shortlisted' },
    { value: 'Not Shortlisted', label: 'Not Shortlisted' },
  ];
  const dateOptions = [
    { value: 'All', label: 'All Dates' },
    { value: 'Last 7 days', label: 'Last 7 days' },
    { value: 'Last 30 days', label: 'Last 30 days' },
    { value: 'Last 90 days', label: 'Last 90 days' },
  ];
  const pageSizeOptions = ['05', '10', '15'];
 
  // Filter candidates
  const filteredCandidates = candidates.filter(c => {
    const query = searchTerm.trim().toLowerCase();
    if (query) {
      const haystack = [c.name, c.email, c.mobile_no, c.skill, c.exam_title, c.college_name, c.degree].filter(Boolean).join(' ').toLowerCase();
      if (!haystack.includes(query)) return false;
    }
 
    // Status filter
    if (statusFilter !== 'All') {
      const isShortlisted = String(c.result_status || '').toLowerCase() === 'passed';

      if (statusFilter === 'Shortlisted' && !isShortlisted)          return false;
      if (statusFilter === 'Not Shortlisted' && isShortlisted)       return false;
    }
 
    // Exam filter
    if (examFilter !== 'All') {
      if ((c.exam_title || '') !== examFilter) return false;
    }
 
    // Date filter
    if (dateFilter !== 'All') {
      const createdDate = new Date(c.created_at);
      const now = new Date();
      const daysDiff = Math.floor((now - createdDate) / (1000 * 60 * 60 * 24));
      if (dateFilter === 'Last 7 days'  && daysDiff > 7)  return false;
      if (dateFilter === 'Last 30 days' && daysDiff > 30) return false;
      if (dateFilter === 'Last 90 days' && daysDiff > 90) return false;
    }
 
    return true;
  });
 
  const sortedCandidates = filteredCandidates;
 
  // Pagination
  const totalPages = Math.max(1, Math.ceil(sortedCandidates.length / pageSize));
  const paginatedCandidates = sortedCandidates.slice((currentPage - 1) * pageSize, currentPage * pageSize);
 
  // Reset to page 1 whenever filters change
  const handleFilterChange = (setter) => (val) => { setter(val); setCurrentPage(1); };
  const handlePageSizeChange = (val) => {
    setPageSize(Number(val));
    setCurrentPage(1);
  };
 
  return (
    <div className="cp-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
 
      {/* ── Navbar ── */}
      <nav className="cp-navbar">
        <img src={logo} alt="logo" className="cp-logo" />
        <div className="cp-navbar-title">
          <h1 className="cp-navbar-heading">Candidates</h1>
          <p className="cp-navbar-sub">{candidates.length} total candidates</p>
        </div>
        <div className="cp-navbar-right">
          <button className="cp-add-btn" onClick={handleOpenModal}>
            <span className="cp-add-plus">+</span> Add Candidate
          </button>
          <div className="cp-navbar-profile">
            <ProfileDropdown user={storedUser.name || storedUser.email} email={storedUser.email} />
          </div>
        </div>
      </nav>
 
      {/* ── Sidebar ── */}
      <aside className="cp-sidebar">
        {sidebarItems
          .filter(item => !(storedUser.role === 'junior_recruiter' && item.path === '/question-bank'))
          .map(({ label, Icon, path }, index) => {
          const isActive = location.pathname === path;
          return (
            <div
              key={label}
              onClick={() => { if (path) navigate(path); }}
              className={`cp-sidebar-item ${isActive ? 'active' : ''}`}
              style={{ top: `${140 + index * 64}px` }}
            >
              <span className="cp-sidebar-icon"><Icon active={isActive} /></span>
              <span className="cp-sidebar-text">{label}</span>
            </div>
          );
        })}
      </aside>
 
      {/* ── Main Content ── */}
      <main className="cp-main">
        <div className="cp-main-inner">
 
          {/* Filter Bar */}
          <div className="cp-filter-bar">
            <div className="cp-search-box">
              <svg className="cp-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="6" stroke="#7AA2F7" strokeWidth="1.8"/>
                <path d="M20 20L16.65 16.65" stroke="#7AA2F7" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
              <input
                type="text"
                className="cp-search-input"
                placeholder="Search candidates..."
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              />
            </div>
 
            <div className="cp-filter-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M4 7H20M7 12H17M10 17H14" stroke="#64748B" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
              <span>Filters</span>
            </div>
 
            <div className="cp-filter-group">
              <div className="cp-select-wrap">
                <PrettySelect
                  value={statusFilter}
                  onChange={handleFilterChange(setStatusFilter)}
                  options={statusOptions}
                  icon={selectIcons.status}
                />
              </div>
            </div>
            <div className="cp-filter-group">
              <div className="cp-select-wrap">
                <PrettySelect
                  value={examFilter}
                  onChange={handleFilterChange(setExamFilter)}
                  options={examOptions}
                  icon={selectIcons.exam}
                />
              </div>
            </div>
            <div className="cp-filter-group">
              <div className="cp-select-wrap">
                <PrettySelect
                  value={dateFilter}
                  onChange={handleFilterChange(setDateFilter)}
                  options={dateOptions}
                  icon={selectIcons.date}
                />
              </div>
            </div>
          </div>
 
          {/* Bulk Action Bar */}
          {selectedIds.size > 0 && (
            <div className="cp-bulk-bar">
              <span className="cp-bulk-bar-text">{selectedIds.size} candidate{selectedIds.size !== 1 ? 's' : ''} selected</span>
              <button className="cp-bulk-assign-btn" onClick={() => openAssignModal([...selectedIds])}>
                Assign Exam
              </button>
              <button className="cp-bulk-clear-btn" onClick={() => setSelectedIds(new Set())}>Clear</button>
            </div>
          )}
 
          {/* Table */}
          <div className="cp-table-wrap">
            <div className="cp-table-card">
            {/* Table Header */}
            <div className="cp-table-header">
              <span className="cp-th cp-th-serial">Sl.No</span>
              <span className="cp-th cp-th-candidate">Candidate</span>
              <span className="cp-th cp-th-college">College</span>
              <span className="cp-th cp-th-degree">Degree</span>
              <span className="cp-th cp-th-skill">Primary Skill</span>
              <span className="cp-th cp-th-exam">Last Assessment</span>
              <span className="cp-th cp-th-score">Score</span>
              <span className="cp-th cp-th-status">Status</span>
              <span className="cp-th cp-th-actions">Actions</span>
            </div>
          <div className="cp-table-wrapper">
            {/* Table Body */}
            <div className="cp-table-body">
              {loading ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#6B7280' }}>Loading...</div>
              ) : paginatedCandidates.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#6B7280' }}>No candidates found.</div>
              ) : paginatedCandidates.map((c, index) => {
                const rowNumber = (currentPage - 1) * pageSize + index + 1;
                const isShortlisted = String(c.result_status || '').toLowerCase() === 'passed';
                const statusLabel = isShortlisted ? 'Shortlisted' : 'Not Shortlisted';
                const statusStyles = isShortlisted
                  ? { color: '#15803D', background: '#DCFCE7' }
                  : { color: '#6B7280', background: '#F3F4F6' };
                const statusIconType = isShortlisted ? 'check' : 'clock';
                const lastAssessmentDate = c.recent_attempt_submitted_at
                  ? new Date(c.recent_attempt_submitted_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
                  : '-';
                return (
                <div
                  key={c.id}
                  className={`cp-row${selectedIds.has(c.id) ? ' cp-row--selected' : ''}`}
                  onClick={() => handleOpenCandidateDetail(c)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="cp-cell cp-cell-serial">
                    <span className="cp-serial-num">{rowNumber}</span>
                  </div>
                  <div className="cp-cell cp-cell-candidate">
                    <div className="cp-candidate-info">
                      <p className="cp-candidate-name" title={c.name}>{c.name}</p>
                      <p className="cp-candidate-email" title={c.mobile_no || c.email}>{c.mobile_no || '-'}</p>
                    </div>
                  </div>
                  <div className="cp-cell cp-cell-college" style={{ justifyContent: (c.college_name || c.college) ? 'flex-start' : 'center' }}>
                    <span className="cp-skill-text" title={c.college_name || c.college || '-'}>{c.college_name || c.college || '-'}</span>
                  </div>
                  <div className="cp-cell cp-cell-degree" style={{ justifyContent: c.degree ? 'flex-start' : 'center' }}>
                    <span className="cp-skill-text" title={c.degree || '-'}>{c.degree || '-'}</span>
                  </div>
 
                  <div className="cp-cell cp-cell-skill">
                    <span className="cp-skill-text" title={c.skill || 'N/A'}>{c.skill || 'N/A'}</span>
                  </div>
 
                  <div className="cp-cell cp-cell-exam">
                    <p className="cp-exam-name" title={lastAssessmentDate}>{lastAssessmentDate}</p>
                    <p className="cp-exam-date">
                      {c.due_date
                        ? `Due: ${new Date(c.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
                        : (c.created_at ? new Date(c.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—')
                      }
                    </p>
                  </div>
 
                  <div className="cp-cell cp-cell-score">
                    {c.percentage !== null && c.percentage !== undefined ? (
                      <div className="cp-score-wrap cp-score-wrap--stacked">
                        <span className="cp-score-num" style={{ fontWeight: 700, fontSize: '1rem', color: c.percentage >= 60 ? '#10B981' : '#F59E0B' }}>
                          {Math.round(c.percentage)}%
                        </span>
                        <span className="cp-score-label">
                          {c.percentage >= 85 ? 'Excellent' : c.percentage >= 60 ? 'Good' : 'Needs Review'}
                        </span>
                      </div>
                    ) : (
                      <span className="cp-skill-text">-</span>
                    )}
                  </div>
 
                  <div className="cp-cell cp-cell-status">
                    <span className="cp-status-badge" style={statusStyles}>
                      <StatusIcon type={statusIconType} color={statusStyles.color} />
                      {statusLabel}
                    </span>
                  </div>
 
                  <div className="cp-cell cp-cell-actions">
                    <button className="cp-edit-btn cp-icon-action-btn" title="Edit candidate" aria-label="Edit candidate" onClick={(e) => { e.stopPropagation(); setCandidateToEdit(c); }}><PencilIcon /></button>
                  </div>
                </div>
                );
              })}
            </div>
          </div>
          </div>
 
          {/* Pagination */}
          {false && !loading && sortedCandidates.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 20px', borderTop: '1px solid #F1F5F9', background: '#fff', borderRadius: '0 0 12px 12px' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>
                Showing {Math.min((currentPage - 1) * pageSize + 1, sortedCandidates.length)}–{Math.min(currentPage * pageSize, sortedCandidates.length)} of {sortedCandidates.length} candidates
              </span>
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                <button
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', background: currentPage === 1 ? '#F9FAFB' : '#fff', color: currentPage === 1 ? '#D1D5DB' : '#374151', fontSize: '13px', fontWeight: 500, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                >← Prev</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(pg => (
                  <button
                    key={pg}
                    onClick={() => setCurrentPage(pg)}
                    style={{ padding: '6px 11px', borderRadius: '8px', border: '1px solid', borderColor: pg === currentPage ? '#2563EB' : '#E5E7EB', background: pg === currentPage ? '#2563EB' : '#fff', color: pg === currentPage ? '#fff' : '#374151', fontSize: '13px', fontWeight: pg === currentPage ? 700 : 500, cursor: 'pointer', minWidth: '34px' }}
                  >{pg}</button>
                ))}
                <button
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', background: currentPage === totalPages ? '#F9FAFB' : '#fff', color: currentPage === totalPages ? '#D1D5DB' : '#374151', fontSize: '13px', fontWeight: 500, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                >Next →</button>
              </div>
            </div>
          )}
          {!loading && sortedCandidates.length > 0 && (
            <div className="cp-pagination-bar">
              <div className="cp-pagination-controls">
                <button
                  className="cp-page-btn cp-page-btn--ghost"
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                >{"<<"} Prev</button>
                <button
                  className="cp-page-btn cp-page-btn--ghost"
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                >{"<"} Prev</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(pg => (
                  <button
                    key={pg}
                    className={`cp-page-btn ${pg === currentPage ? 'cp-page-btn--active' : ''}`}
                    onClick={() => setCurrentPage(pg)}
                  >{pg}</button>
                ))}
                <button
                  className="cp-page-btn cp-page-btn--ghost"
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                >Next {">"}</button>
                <button
                  className="cp-page-btn cp-page-btn--ghost"
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                >Next {">>"}</button>
              </div>
              <div className="cp-items-per-page">
                <div className="cp-items-select-wrap">
                  <PrettySelect
                    value={String(pageSize).padStart(2, '0')}
                    onChange={handlePageSizeChange}
                    options={pageSizeOptions}
                    className="cp-items-select"
                  />
                </div>
                <span>Items per page</span>
              </div>
            </div>
          )}
        </div>
        </div>
      </main>
 
      {/* ── Conditional Modal Logic ── */}
      {showModal && modalStep === 'selection' && (
        <AddCandidateModal
          onClose={() => setShowModal(false)}
          onSingleEntry={() => setModalStep('form')}
          onBulkUpload={() => setModalStep('bulk')}
        />
      )}
 
      {showModal && modalStep === 'form' && (
        <SingleEntryForm onClose={() => setShowModal(false)} onNotify={handleToast} />
      )}
 
      {showModal && modalStep === 'bulk' && (
        <BulkUploadForm onClose={() => setShowModal(false)} onNotify={handleToast} />
      )}
 
      {showAssignModal && (
        <AssignExamModal
          candidateIds={assignTargetIds}
          onClose={() => setShowAssignModal(false)}
          onAssigned={handleAssigned}
        />
      )}

      {candidateToEdit && (
        <EditCandidateModal
          candidate={candidateToEdit}
          onClose={() => setCandidateToEdit(null)}
          onSaved={handleCandidateSaved}
          onNotify={handleToast}
        />
      )}

      {candidateDetail && (
        <div className="cp-modal-overlay" onClick={() => { clearScreenshotBlobUrls(); setCandidateDetail(null); }}>
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: '16px',
              width: 'min(720px, calc(100vw - 48px))',
              maxHeight: 'calc(100vh - 64px)',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 24px 64px rgba(15,23,42,0.22)',
              overflow: 'hidden',
            }}
          >
            <div style={{ padding: '24px 28px 16px', borderBottom: '1px solid #F1F5F9', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <div>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#111827' }}>{candidateDetail.name}</h2>
                <p style={{ margin: '5px 0 0', fontSize: '13px', color: '#64748B' }}>Candidate attempt details</p>
              </div>
              <button onClick={() => { clearScreenshotBlobUrls(); setCandidateDetail(null); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94A3B8', fontSize: '22px', lineHeight: 1, padding: '2px 6px' }}>×</button>
            </div>

            <div style={{ padding: '20px 28px', display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '14px', borderBottom: '1px solid #F1F5F9' }}>
              {[
                
                { label: 'Email', value: candidateDetail.email || '—' },
                { label: 'Mobile No.', value: candidateDetail.mobile_no || '—' },
                { label: 'College', value: candidateDetail.college_name || candidateDetail.college || '—' },
                { label: 'Degree', value: candidateDetail.degree || '—' },
                { label: 'Exam Attempted', value: candidateDetail.examTitle || '—' },
                { label: 'Status', value: candidateDetail.submit_reason === 'tab_switch' ? 'Defaulter' : (candidateDetail.assignment_status || '—') },
                { label: 'Score', value: candidateDetail.percentage != null ? `${candidateDetail.percentage}%` : '—' },
                { label: 'Submitted On', value: candidateDetail.submitted_at ? new Date(candidateDetail.submitted_at).toLocaleString('en-IN') : '—' },
                { label: 'Violation', value: formatViolationLabel(candidateDetail.submit_reason, candidateDetail.tab_switch_count) },
                { label: 'Tab Switches', value: candidateDetail.tab_switch_count ?? 0 },
              ].map(({ label, value }) => (
                <div key={label} style={{ background: '#F8FAFC', borderRadius: '10px', padding: '12px 14px' }}>
                  <div style={{ fontSize: '11px', color: '#94A3B8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
                  <div title={String(value)} style={{ fontSize: '14px', fontWeight: 600, color: '#1E293B', marginTop: '5px', wordBreak: 'break-word' }}>{value}</div>
                </div>
              ))}
            </div>

            <div style={{ padding: '20px 28px 28px', overflowY: 'auto' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px', fontWeight: 700, color: '#374151' }}>Screenshots</h3>
              {candidateEvidenceLoading ? (
                <p style={{ color: '#94A3B8', fontSize: '13px' }}>Loading screenshots…</p>
              ) : candidateDetail.screenshots?.length ? (
                <div style={{ display: 'grid', gap: '10px' }}>
                  {candidateDetail.screenshots.map((shot) => (
                    <a
                      key={shot.filename}
                      href={shot.blobUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOpenScreenshot(shot.blobUrl);
                      }}
                      style={{ display: 'flex', width: '100%', background: '#fff', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', border: '1px solid #E5E7EB', borderRadius: '10px', textDecoration: 'none', color: '#2563EB', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}
                    >
                      <span title={shot.filename} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{shot.filename}</span>
                      <span>Open screenshot</span>
                    </a>
                  ))}
                </div>
              ) : (
                <p style={{ color: '#94A3B8', fontSize: '13px' }}>No screenshots found for this candidate.</p>
              )}
            </div>
          </div>
        </div>
      )}
 
    </div>
  );
};
 
export default CandidatePage;
 

